package ui.app.assign.detail

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import common.frontend.api.Io
import tools.EFieldList
import tools.EFieldRegularBoolean

class AppWrapperDevices(
    data: Io.AppDetail,
    private var initial: List<Boolean> = emptyList(),
    private val changeInternal: MutableState<Boolean> = mutableStateOf(false),
    val onChangeInvoke: () -> Unit = {},
) : EFieldList<Io.AppDetail.DeviceItem, AppWrapperDevices.Item>(
    items = data.locations.map { it.devices }.flatten().toMutableList(),
    onBindEntry = { data ->
        Item(data) {
            changeInternal.value = state.map { it.isActive.state } != initial
            onChangeInvoke()
        }
    }
) {

    override fun applyChanges() {
        initial = state.map { it.isActive.state }
    }

    override var change by changeInternal

    init {
        applyChanges()
    }

    class Item(
        override val data: Io.AppDetail.DeviceItem,
        override val key: String = data.id.toString(),
        private val onChange: (() -> Unit)
    ) : Entry<Io.AppDetail.DeviceItem> {
        val isActive = EFieldRegularBoolean(
            property = data::enabled,
            onChange = { onChange() }
        )
    }
}